import { interpolate, useCurrentFrame } from "remotion";
import { neon } from "./Materials";
import { BRAND } from "./theme";

type Vec3 = [number, number, number];

/** Glowing node (sphere). Compose into diagrams. */
export const Node3D: React.FC<{
  position: Vec3;
  color?: string;
  size?: number;
}> = ({ position, color = BRAND.cyan, size = 0.4 }) => (
  <mesh position={position}>
    <sphereGeometry args={[size, 32, 32]} />
    <meshStandardMaterial {...neon(color)} />
  </mesh>
);

/** Thin emissive edge connecting two points (in the XY plane). */
export const Edge3D: React.FC<{
  from: Vec3;
  to: Vec3;
  color?: string;
  thickness?: number;
}> = ({ from, to, color = BRAND.violet, thickness = 0.02 }) => {
  const mid: Vec3 = [
    (from[0] + to[0]) / 2,
    (from[1] + to[1]) / 2,
    (from[2] + to[2]) / 2,
  ];
  const len = Math.hypot(to[0] - from[0], to[1] - from[1], to[2] - from[2]);
  const angle = Math.atan2(to[1] - from[1], to[0] - from[0]);
  return (
    <mesh position={mid} rotation={[0, 0, angle]}>
      <boxGeometry args={[len, thickness, thickness]} />
      <meshStandardMaterial {...neon(color, 0.8)} />
    </mesh>
  );
};

/** A small mesh travelling from->to over [startFrame, startFrame+travelFrames]. */
export const DataParticle: React.FC<{
  from: Vec3;
  to: Vec3;
  startFrame?: number;
  travelFrames?: number;
  color?: string;
  size?: number;
}> = ({
  from,
  to,
  startFrame = 0,
  travelFrames = 30,
  color = BRAND.green,
  size = 0.09,
}) => {
  const frame = useCurrentFrame();
  const p = interpolate(frame - startFrame, [0, travelFrames], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const pos: Vec3 = [
    from[0] + (to[0] - from[0]) * p,
    from[1] + (to[1] - from[1]) * p,
    from[2] + (to[2] - from[2]) * p,
  ];
  return (
    <mesh position={pos}>
      <sphereGeometry args={[size, 16, 16]} />
      <meshStandardMaterial {...neon(color, 2)} />
    </mesh>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
